import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import UserApplicationCard from "../../components/molecules/UserApplicationCard";
import UserApplicationModal from "../../components/molecules/UserApplicationModal";
import SectionBox from "../../components/layout/SectionBox";
import MainLayoutUser from "../../components/layout/MainLayoutUser";
import Footer from "../../components/organisms/Footer";
import { useUserApplicationsStore } from "../../store/useUserApplicationsStore";

export default function UserDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const lang: "en" | "id" = location.pathname.startsWith("/id") ? "id" : "en";
  const [selectedCandidate, setSelectedCandidate] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  const {
    activeTab,
    setActiveTab,
    page,
    setPage,
    data,
    meta,
    counts,
    loading,
    fetchApplications,
  } = useUserApplicationsStore();

  useEffect(() => {
    fetchApplications(activeTab);
  }, [activeTab, page]);

  // ---------------------------
  // Mapper dari ApplicationItem ke Card
  type ApplicationCardData = any

  type ApplicationStatus = "applied" | "reviewed" | "interviewed" | "hired" | "rejected";

  type ApplicationItem = {
    candidate: any;
    id: number;
    status: ApplicationStatus;
    applied_at: string;

    vacancy: any

    resume_path: string;
    resume_name: string;
    cover_letter: string;
  };


  const mapApplicationToCard = (
    item: ApplicationItem,
    lang: "en" | "id"
  ): ApplicationCardData => ({
    companyLogo: item.vacancy?.company_logo || undefined,
    positionApplied: item.vacancy?.name?.[lang] || "-",
    workingType: item.vacancy?.working_type_name?.[lang] || "-",
    industry: item.vacancy?.industry_name?.[lang] || "-",
    degree: item.vacancy?.degree_name?.[lang] || "-",
    expYear: item.vacancy?.experience_year_name?.[lang] || "-",
    expLevel: item.vacancy?.experience_level_name?.[lang] || "-",
    country: item.vacancy?.country_name || "-",
    state: item.vacancy?.state_name || "-",
    city: item.vacancy?.city_name|| "-",
    jobType: item.vacancy?.job_type_name?.[lang] || "-",
    companyName: item.vacancy?.company_name || "-",
    cv: item.candidate?.resume || "-",
    appliedDate: item.applied_at,
    status:
      item.status === "applied"
        ? "pending"
        : item.status === "hired"
          ? "approved"
          : item.status === "rejected"
            ? "rejected"
            : item.status === "reviewed"
              ? "in-review" // atau bisa ganti sesuai label, misal "in-review"
              : item.status === "interviewed"
                ? "in-interview" // atau "in-interview"
                : "pending",

  });



  const openDetailModal = (item: ApplicationItem) => {
    setSelectedCandidate({
      companyLogo: item.vacancy.company_logo || undefined,
      positionApplied: item.vacancy.name[lang] || "-",
      workingType: item.vacancy.working_type_name[lang] || "-",
      industry: item.vacancy.industry_name[lang] || "-",
      degree: item.vacancy.degree_name[lang] || "-",
      expYear: item.vacancy.experience_year_name[lang] || "-",
      expLevel: item.vacancy.experience_level_name[lang] || "-",
      country: item.vacancy.country_name || "-",
      state: item.vacancy.state_name || "-",
      city: item.vacancy.city_name || "-",
      jobType: item.vacancy.job_type_name[lang] || "-",
      companyName: item.vacancy.company_name,
      appliedDate: item.applied_at,
      responsibility: item.vacancy.responsibility?.[lang] || "-",
      requirement: item.vacancy.requirement?.[lang] || "-",
      benefit: item.vacancy.benefits?.map((b: any) => ({ id: b.id, name: b.name[lang] })) || [],
      skills: item.vacancy.skills?.map((s: any) => ({ id: s.id, name: s.name })) || [],
      minSalary: item.vacancy.min_salary || "-",
      maxSalary: item.vacancy.max_salary || "-",
      showSalary: item.vacancy.show_salary || false,
      cv: item.candidate.resume,
      status:
        item.status === "applied"
          ? "pending"
          : item.status === "hired"
            ? "approved"
            : item.status === "rejected"
              ? "rejected"
              : item.status === "reviewed"
                ? "in-review"
                : item.status === "interviewed"
                  ? "in-interview" 
                  : "pending",

    });
    setShowModal(true);
  };


  const user = {
    name: "Yusri Hilmi Muhammad",
    photo: "https://i.pravatar.cc/200?img=11",
    position: "Frontend Developer",
  };

  const changeTab = (tab: "applied" | "reviewed" | "interviewed" | "hired" | "rejected") => {
    setActiveTab(tab);
    setPage(1);
  };

  // Ambil data sesuai tab
  const tabs = {
    applied: data.applied || [],
    reviewed: data.reviewed || [],
    interviewed: data.interviewed || [],
    hired: data.hired || [],
    rejected: data.rejected || [],
  };
  const paginatedData: ApplicationCardData[] = tabs[activeTab].map((item) =>
    mapApplicationToCard(item, lang)
  );


  // Ambil total page
  const pagination = meta[activeTab];
  const currentPage = pagination?.current_page ?? 1;
  const totalPages = pagination?.last_page ?? 1;

  

  return (
    <>
      <MainLayoutUser>
        <main>
          <div className="container-section mx-auto px-6 pt-6 pb-6">
            <SectionBox title="My Application" titleClassName="text-white font-semibold" className="mt-24">
              <div className="flex flex-col lg:flex-row gap-6 mt-6">

                {/* SIDEBAR */}
                {/* <div className="w-full lg:w-72 bg-white border rounded-xl p-5 h-fit shadow-sm text-center">
                  <img
                    src={user.photo}
                    className="w-28 h-28 rounded-full object-cover mx-auto"
                  />
                  <h2 className="text-xl font-semibold mt-4">{user.name}</h2>
                  <p className="text-gray-600 text-sm">{user.position}</p>
                </div> */}

                {/* CONTENT */}
                <div className="flex-1 bg-white border rounded-xl p-4 sm:p-6 shadow-sm">

                  {/* Tabs Desktop */}
                  <div className="hidden sm:flex gap-6 border-b pb-3 mb-5">
                    <button
                      className={activeTab === "applied" ? "font-semibold" : ""}
                      onClick={() => changeTab("applied")}
                    >
                      {lang === "id" ? "Aplikasi" : "Application"} ({counts?.applied ?? 0})
                    </button>

                    <button
                      className={activeTab === "reviewed" ? "font-semibold" : ""}
                      onClick={() => changeTab("reviewed")}
                    >
                      {lang === "id" ? "Direview" : "Reviewed"} ({counts?.reviewed ?? 0})
                    </button>

                    <button
                      className={activeTab === "interviewed" ? "font-semibold" : ""}
                      onClick={() => changeTab("interviewed")}
                    >
                      {lang === "id" ? "Diinterview" : "Interviewed"} ({counts?.interviewed ?? 0})
                    </button>

                    <button
                      className={activeTab === "hired" ? "font-semibold" : ""}
                      onClick={() => changeTab("hired")}
                    >
                      {lang === "id" ? "Diterima" : "Hired"} ({counts?.hired ?? 0})
                    </button>

                    <button
                      className={activeTab === "rejected" ? "font-semibold" : ""}
                      onClick={() => changeTab("rejected")}
                    >
                      {lang === "id" ? "Ditolak" : "Rejected"} ({counts?.rejected ?? 0})
                    </button>
                  </div>

                  {/* Tabs Mobile */}
                  <div className="sm:hidden mb-5">
                    <select
                      value={activeTab}
                      onChange={(e) => changeTab(e.target.value as any)}
                      className="w-full border rounded-md p-2"
                    >
                      <option value="applied">
                        {lang === "id" ? "Aplikasi" : "Application"} ({counts?.applied ?? 0})
                      </option>
                      <option value="reviewed">
                        {lang === "id" ? "Direview" : "Reviewed"} ({counts?.reviewed ?? 0})
                      </option>
                      <option value="interviewed">
                        {lang === "id" ? "Diinterview" : "Interviewed"} ({counts?.interviewed ?? 0})
                      </option>
                      <option value="hired">
                        {lang === "id" ? "Diterima" : "Hired"} ({counts?.hired ?? 0})
                      </option>
                      <option value="rejected">
                        {lang === "id" ? "Ditolak" : "Rejected"} ({counts?.rejected ?? 0})
                      </option>
                    </select>
                  </div>

                  {/* List */}
                  {paginatedData.length === 0 ? (
                    <p className="text-gray-500 text-center mt-20">
                      {lang === "id" ? "Tidak ada aplikasi" : "No applications found"}
                    </p>
                  ) : (
                    <div className="flex flex-col gap-4">
                      {paginatedData.map((item, i) => (
                        <UserApplicationCard
                          key={i}
                          application={item}
                          lang={lang}
                          onViewDetail={() => openDetailModal(tabs[activeTab][i])}
                        />
                      ))}
                    </div>
                  )}


                  {/* Pagination */}
                  {/* Pagination */}
<div className="flex justify-center items-center gap-4 mt-6">
  <button
    disabled={currentPage <= 1}
    onClick={() => setPage(currentPage - 1)}
    className={`px-4 py-2 border rounded ${
      currentPage <= 1 ? "opacity-50 cursor-not-allowed" : ""
    }`}
  >
    Prev
  </button>

  <span>
    Page {currentPage} of {totalPages}
  </span>

  <button
    disabled={currentPage >= totalPages}
    onClick={() => setPage(currentPage + 1)}
    className={`px-4 py-2 border rounded ${
      currentPage >= totalPages ? "opacity-50 cursor-not-allowed" : ""
    }`}
  >
    Next
  </button>
</div>


                  {/* Modal */}
                  {showModal && (
                    <UserApplicationModal
                      data={selectedCandidate}
                      onClose={() => setShowModal(false)}
                      lang={lang}
                    />
                  )}
                </div>
              </div>
            </SectionBox>
          </div>
        </main>
      </MainLayoutUser>

      <Footer />
    </>
  );
}
